<template>
  <div class="row justify-content-center">
    <div class="col-lg-10 col-md-12">
      <card shadow type="secondary" class="border-0 mb-0">
        <template slot="header">
          <div class="text-center">
            <h2 class="text-dark">Privacy Policy</h2>
            <p class="text-muted">Last updated: January 29, 2026</p>
          </div>
        </template>

        <div class="px-lg-4">
          <h4>1. Introduction</h4>
          <p>Welcome to Quran Clip Helper ("we," "our," or "us"). We are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, and safeguard your data when you use our website at qurancliphelper.com.</p>

          <h4>2. Information We Collect</h4>
          <p><strong>Information You Provide:</strong></p>
          <ul>
            <li>Audio files you upload for video creation (temporarily stored during processing)</li>
            <li>Images or videos you upload as backgrounds (temporarily stored during processing)</li>
          </ul>
          <p><strong>Automatically Collected Information:</strong></p>
          <ul>
            <li>IP address (hashed for privacy in our analytics)</li>
            <li>Browser type and version</li>
            <li>Pages visited and features used</li>
            <li>Date and time of visits</li>
            <li>Referring website</li>
          </ul>

          <h4>3. How We Use Your Information</h4>
          <p>We use the collected information to:</p>
          <ul>
            <li>Process your audio files and generate video clips</li>
            <li>Improve our services and user experience</li>
            <li>Monitor and analyze usage patterns</li>
            <li>Prevent abuse and maintain service quality</li>
            <li>Respond to your inquiries</li>
          </ul>

          <h4>4. Data Storage and Retention</h4>
          <ul>
            <li><strong>Uploaded Files:</strong> Audio, image, and video files you upload are temporarily stored only during the video creation process and are automatically deleted after processing is complete.</li>
            <li><strong>Generated Videos:</strong> Completed videos are available for download for a limited time before being automatically deleted from our servers.</li>
            <li><strong>Analytics Data:</strong> Aggregated, anonymized usage data may be retained for service improvement purposes.</li>
          </ul>

          <h4>5. Third-Party Services</h4>
          <p>We use the following third-party services:</p>
          <ul>
            <li><strong>Google Analytics (GA4):</strong> For website analytics and usage tracking. See Google's Privacy Policy at <a href="https://policies.google.com/privacy" target="_blank">policies.google.com/privacy</a></li>
            <li><strong>Google Gemini AI:</strong> For analyzing audio files and detecting Quran recitation. Audio is processed through Google's AI services.</li>
            <li><strong>Quran.com API:</strong> For fetching Quranic text and translations.</li>
            <li><strong>QuranWBW:</strong> For word-by-word translation data.</li>
          </ul>

          <h4>6. Cookies</h4>
          <p>We use cookies and similar technologies to:</p>
          <ul>
            <li>Remember your preferences</li>
            <li>Analyze site traffic and usage</li>
            <li>Improve our services</li>
          </ul>
          <p>You can control cookies through your browser settings.</p>

          <h4>7. Data Security</h4>
          <p>We implement appropriate technical and organizational measures to protect your data, including:</p>
          <ul>
            <li>Secure HTTPS connections</li>
            <li>Hashing of IP addresses in analytics</li>
            <li>Automatic deletion of uploaded files after processing</li>
            <li>Rate limiting to prevent abuse</li>
          </ul>

          <h4>8. Your Rights</h4>
          <p>You have the right to:</p>
          <ul>
            <li>Access information about data we hold about you</li>
            <li>Request deletion of your data</li>
            <li>Opt-out of analytics tracking</li>
            <li>Contact us with privacy concerns</li>
          </ul>

          <h4>9. Children's Privacy</h4>
          <p>Our service is available to users of all ages. We do not knowingly collect personal information from children under 13 without parental consent. If you believe we have collected such information, please contact us.</p>

          <h4>10. Changes to This Policy</h4>
          <p>We may update this Privacy Policy from time to time. We will notify users of significant changes by posting the new policy on this page with an updated revision date.</p>

          <h4>11. Contact Us</h4>
          <p>If you have questions about this Privacy Policy, please contact us at:</p>
          <ul>
            <li>Email: moazelsayedquran@gmail.com</li>
            <li>Instagram: instagram.com/moazquran</li>
          </ul>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy'
}
</script>
